const HERMES_GPT = {
  value: 'hermes_gpt',
  label: 'Hermes GPT',
};

const HERMES_GROK = {
  value: 'hermes_grok',
  label: 'Hermes Grok',
};

const GROK_API_NON_REASONING = {
  value: 'grok_api_non_reasoning',
  label: 'Grok API Non-Reasoning',
};

const BUILDER_STACK_OPTIONS = [
  HERMES_GPT,
  HERMES_GROK,
];

const RUNTIME_STACK_OPTIONS = [
  HERMES_GPT,
  HERMES_GROK,
  GROK_API_NON_REASONING,
];

const ROLE_STACK_OPTIONS = {
  builderStack: BUILDER_STACK_OPTIONS,
  runtimeStack: RUNTIME_STACK_OPTIONS,
  latencyStack: RUNTIME_STACK_OPTIONS,
};

export const rebuiltCreatorProviderStackOptionsForRole = (role) => (
  ROLE_STACK_OPTIONS[role] || BUILDER_STACK_OPTIONS
);

export const rebuiltCreatorProviderStackValuesForRole = (role) => (
  rebuiltCreatorProviderStackOptionsForRole(role).map((option) => option.value)
);
